import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useContext } from "react";
import { css } from "styled-components";

export interface OriginalOrderNumberCustomerPoStyles {
    outerWrapper?: InjectableCss;
    wrapper?: InjectableCss;
    titleText?: TypographyProps;
    customerPo?: TypographyProps;
}

export const originalOrderNumberCustomerPoStyles: OriginalOrderNumberCustomerPoStyles = {
    outerWrapper: {
        css: css`
            display: flex;
        `,
    },
    wrapper: {
        css: css`
            padding-bottom: 10px;
            flex-basis: 50%;
            max-width: 50%;
        `,
    },
    titleText: {
        variant: "h6",
        as: "h2",
        css: css`
            @media print {
                font-size: 12px;
            }
            margin-bottom: 5px;
        `,
    },
};

const styles = originalOrderNumberCustomerPoStyles;

const WorkOrderCustomerPo: FC = () => {
    const { value: order } = useContext(OrderStateContext);
    if (!order) {
        return null;
    }

    return (
        <StyledWrapper {...styles.outerWrapper}>
            {order.properties["orderNumberForRma"] && (
                <StyledWrapper {...styles.wrapper}>
                    <Typography {...styles.titleText} id="customerPo">
                        {translate("Original Order #")}
                    </Typography>
                    <Typography {...styles.customerPo} aria-labelledby="customerPo">
                        {order.properties["orderNumberForRma"]}
                    </Typography>
                </StyledWrapper>
            )}
            {order.customerPO && (
                <StyledWrapper {...styles.wrapper}>
                    <Typography {...styles.titleText} id="customerPo">
                        {translate("Customer PO")}
                    </Typography>
                    <Typography {...styles.customerPo} aria-labelledby="customerPo">
                        {order.customerPO}
                    </Typography>
                </StyledWrapper>
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: WorkOrderCustomerPo,
    definition: {
        allowedContexts: ["WorkOrderDetailsPage"] as any,
        group: "Order Details",
    },
};

export default widgetModule;
